<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="primary"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Labeltypes") }}
        </div>
      </template>
      <div class="text-right">
        <v-btn
          class="ma-1"
          color="primary"
          @click="$router.push({ name: 'labelType.create' })"
        >
          {{ $t("create") }}
        </v-btn>
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [10, 15, 50, -1]
        }"
      >
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template></v-data-table
      >
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem } from "../shared/services";
import { persistentTableOptions } from "../../../plugins/mixins";

export default {
  name: "app-labelType-list",
  mixins: [persistentTableOptions],
  data() {
    return {
      loading: true,
      options: {
        itemsPerPage: 50
      },
      total: 0,
      search: "",
      items: []
    };
  },

  mounted() {
    this.getData();
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("Name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$t("Costs"),
          align: "left",
          value: "costs"
        },
        {
          text: this.$t("qty_on_stock"),
          align: "left",
          value: "qty_on_stock"
        },
        {
          text: this.$t("qty_on_order"),
          align: "left",
          value: "qty_on_order"
        },
        { text: "", value: "action", sortable: false }
      ];
    }
  },

  methods: {
    async getData() {
      this.loading = true;
      let response = await fetchItems({ ...this.options, search: this.search });
      this.items = response.data;
      this.total = response.meta.total;
      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Labeltype?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "labelType.edit", params: { id: url } });
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
